<template>
    <div style="font-size: 0.9rem">
        <div style="font-size: 0.8rem">空き状況</div>
        <div style="text-align: center; width: 80px;">
            <div style="background: #D3D3D3;">{{ Data[0] }}</div>
            <div style="background: #ECEEF1; font-family: sans-serif;">{{ Data[1] }}</div>
        </div>
        <div v-if="Loading">空き状況を取得しています</div>
        <div style="color: dimgray;">※既に予約済みの場合は空き無しと表示される可能性があります。</div>
    </div>
</template>

<script>
import { BookingController } from '../../assets/api/bookingController.js'
import Util from "../../assets/utility.js"

export default {
    props: {
        date: {
            type: Date
        },
        time: {
            type: Number
        }
    },
    data() {
        return {
            Loading: true,
            Data: ["",""],
        }
    },
    mounted(){
        this.reload()
    },
    methods: {
        async reload(){
            this.Loading = true
            let s = Util.getDateValue(this.date)

            let res = await new BookingController().getOverview(s, s, 2, false)
            if(!res.ok) return

            /** @type {BookingStatus[]} */
            let books = res.data
            let data = [`${Math.trunc(this.time / 60)}時火葬`, "－"]

            let b = books.find(x=>x.bookingTime == Math.trunc(this.time / 60) * 60)
            if(b != null && b.slotCount > 0){
                data[1] =  b.freeCount > 0 ? "〇" : "×"
            }
            this.Data = data
            this.Loading = false
        },
        formatData(d, format){
            if(!d) return ""
            return Util.formatDate(d, format)
        },
        formatTime(t){
            if(!t==undefined) return ""
            return Util.formatTime(t)
        }
    },
}
</script>

<style scoped>
</style>
